import React from 'react';

import Accordian from 'commons-ui/src/components/keyValueView/Accordian';
import { DataList, Loader } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import { ITournamentDetails } from '../types';

import { columnConfigs } from './listConfig';
import useStyles from './useStyles';
import useOpponentsDetails from './useOpponentsDetails';

interface OpponentsGameDetailsListProps {
	tournamentDetails: ITournamentDetails;
	gameName: string | null | undefined;
}

const OpponentsGameDetailsList: React.FC<OpponentsGameDetailsListProps> = (props) => {
	const { tournamentDetails } = props;
	const { timelineIsCollapsed, setOpponentsListIsCollapsedHandler, dataFetchComplete, showLoader, handleDatalistFetchData } =
		useOpponentsDetails({ tournamentDetails });
	const classes = useStyles();

	const label = (
		<div className={classes.labelWithFilter}>
			<div className={classes.labelText}>Opponents Game Details</div>
		</div>
	);

	return (
		<>
			{showLoader && <Loader />}
			<Accordian
				label={label}
				panelKey='unnamedPanel'
				isCollapsed={timelineIsCollapsed}
				setIsCollapsed={setOpponentsListIsCollapsedHandler}>
				{dataFetchComplete && (
					<DataList
						fetchData={handleDatalistFetchData}
						columnConfigs={columnConfigs}
						hideActions
						entity={LIST_ENTITY_NAMES.OPPONENTS_GAME_DETAILS}
						filterable={false}
						searchable={false}
						height='500px'
					/>
				)}
			</Accordian>
		</>
	);
};

export default OpponentsGameDetailsList;
